import React from 'react';
// Common spam email domains to block
export const spamDomains = ['0-mail.com', '027168.com', '0815.ru', '0815.su', '0clickemail.com', '0wnd.net', '0wnd.org', '10mail.org', '10minutemail.com', '10minutemail.net', '12minutemail.com', 'temp-mail.org', 'tempmail.com', 'mailinator.com', 'guerrillamail.com', 'guerrillamail.net', 'sharklasers.com', 'spam4.me', 'yopmail.com', 'trashmail.com', 'mailnesia.com', 'tempr.email', 'dispostable.com', 'throwawaymail.com', 'getnada.com', 'mailcatch.com', 'tempinbox.com', 'fakeinbox.com', 'emailondeck.com', 'mintemail.com', 'spambog.com', 'spambog.de', 'spambog.ru', 'mytemp.email', 'mytrashmail.com', 'mailforspam.com', 'jetable.org', 'mailexpire.com', 'maildrop.cc', 'mailnull.com', 'spamgourmet.com', 'incognitomail.org', 'meltmail.com', 'discard.email', 'getairmail.com', 'mailsac.com', 'inboxalias.com', 'trashinbox.com', 'emailsensei.com', 'tempmail.ninja', 'faketempmail.com', 'instant-mail.de', 'antireg.ru', 'filzmail.com', 'emaildrop.io', 'tempmailaddress.com', 'temp-mail.io', 'spamex.com', 'disposable-email.ml', 'easytrashmail.com', 'tempmail.space', 'temporarymail.org', 'fakemail.net', 'fakemailgenerator.com', 'emailfake.ml', 'mohmal.com', 'cock.li', 'anonbox.net', 'mailcatch.com', 'disposable.email', 'tempmailz.com', 'anonymbox.com', 'wegwerfmail.de', 'trash-mail.at', 'mailnator.com', 'throwmail.cc', 'emailisvalid.com', 'temp-mail.ru', 'fakemailbox.com', 'emailtemporario.com.br', 'tempmail.plus', 'burnermail.io', 'tempmailo.com', 'mailpoof.com', 'emailna.co', 'fake-box.com', 'emltmp.com', 'dropmail.me', 'tempmail.dev', 'fakemailgenerator.net', 'tempmail.email'];
// Check if email domain is in spam list
export const isSpamEmail = (email: string): boolean => {
  if (!email) return false;
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  return spamDomains.includes(domain);
};
// Generate a simple math captcha
export const generateMathCaptcha = (): {
  question: string;
  answer: number;
} => {
  const num1 = Math.floor(Math.random() * 10) + 1;
  const num2 = Math.floor(Math.random() * 10) + 1;
  const operators = ['+', '-', 'x'];
  const operatorIndex = Math.floor(Math.random() * 3);
  const operator = operators[operatorIndex];
  let answer: number;
  let question: string;
  switch (operator) {
    case '+':
      answer = num1 + num2;
      question = `${num1} + ${num2} = ?`;
      break;
    case '-':
      // Ensure the result is positive
      if (num1 >= num2) {
        answer = num1 - num2;
        question = `${num1} - ${num2} = ?`;
      } else {
        answer = num2 - num1;
        question = `${num2} - ${num1} = ?`;
      }
      break;
    case 'x':
      answer = num1 * num2;
      question = `${num1} × ${num2} = ?`;
      break;
    default:
      answer = num1 + num2;
      question = `${num1} + ${num2} = ?`;
  }
  return {
    question,
    answer
  };
};
// Rate limiting using localStorage
export const checkRateLimit = (formType: string): boolean => {
  const now = Date.now();
  const rateKey = `form_submit_${formType}`;
  const lastSubmit = localStorage.getItem(rateKey);
  if (lastSubmit) {
    const timeSinceLastSubmit = now - parseInt(lastSubmit);
    // Limit to one submission per 30 seconds
    if (timeSinceLastSubmit < 30000) {
      return false;
    }
  }
  // Update last submission time
  localStorage.setItem(rateKey, now.toString());
  return true;
};
// Check for submission timing (too fast is likely a bot)
export const checkSubmissionTiming = (startTime: number): boolean => {
  const submissionTime = Date.now() - startTime;
  // If form is submitted in less than 3 seconds, likely a bot
  return submissionTime > 3000;
};
// Generate a timestamp token for form validation
export const generateTimestampToken = (): string => {
  return Date.now().toString();
};
// Validate form submission with anti-spam checks
export const validateFormSubmission = (email: string, captchaAnswer: string, expectedCaptchaAnswer: number, honeypotValue: string, formType: string, startTime: number): {
  valid: boolean;
  error?: string;
} => {
  // Check honeypot (should be empty)
  if (honeypotValue) {
    console.log('Honeypot triggered');
    return {
      valid: false,
      error: 'Spam detectie geactiveerd'
    };
  }
  // Check submission timing
  if (!checkSubmissionTiming(startTime)) {
    console.log('Submission too fast');
    return {
      valid: false,
      error: 'Formulier te snel verzonden'
    };
  }
  // Check rate limiting
  if (!checkRateLimit(formType)) {
    console.log('Rate limit exceeded');
    return {
      valid: false,
      error: 'Te veel aanvragen. Probeer later opnieuw.'
    };
  }
  // Check captcha
  if (parseInt(captchaAnswer) !== expectedCaptchaAnswer) {
    console.log('Invalid captcha');
    return {
      valid: false,
      error: 'Onjuiste captcha'
    };
  }
  // Check for spam email domains
  if (isSpamEmail(email)) {
    console.log('Spam email detected');
    return {
      valid: false,
      error: 'Ongeldig e-mailadres'
    };
  }
  return {
    valid: true
  };
};